import React, { useEffect } from 'react';
import { MerchantInfo } from 'store/termsAndConditions/termsAndConditionsSlice';
import {
  TermsTextWrapper,
  TermsPlainTextWrapper,
  TermsSubTitle,
  TermsPlainText,
  Paragraph,
  TermsTitle,
  SubParagraph
} from 'pages/styles';

export const LoyaltyTermsAndConditionsFR = (merchantInfo: MerchantInfo) => {
  const { merchantName, pointThreshhold, rewardAmount, privacyPolicyUrl } = merchantInfo;

  const title: string = 'CONDITIONS DE PARTICIPATION AU PROGRAMME DE FIDÉLITÉ';

  useEffect(() => {
    document.title = title;
  }, []);

  return (
    <TermsTextWrapper>
      <TermsPlainTextWrapper>
        <TermsTitle>{title}</TermsTitle>
        <TermsPlainText>
          Les présentes Conditions d&apos;utilisation («Conditions» ou «Conditions d&apos;utilisation») constituent une
          entente légale entre vous («vous» ou «votre») et Global Payments Direct, Inc. (&apos;Global Payments&apos;,
          &apos;nous&apos;, «notre» ou «nos»), et régissent votre accès au programme de fidélité de Global Payments
          ainsi que votre utilisation de celui-ci. Ce programme comprend tout site Web ou application connexe, ou tout
          autre moyen par lequel Global Payments vous permet d&apos;interagir avec nous directement ou par
          l&apos;intermédiaire d&apos;un commerçant utilisant les solutions de point de vente («PDV») de Global
          Payments. Ces solutions permettent à nos clients commerciaux (chacun étant un «Commerçant», collectivement les
          «Commerçants») de traiter des paiements par carte de crédit et de débit et d&apos;exécuter diverses fonctions
          administratives. Dans le cadre de ces solutions de traitement des paiements, notre système PDV comprend des
          services conçus pour aider les Commerçants à vous offrir un programme de fidélité et d&apos;autres avantages
          (le «Programme de fidélité»). En accédant au Programme de fidélité ou en l&apos;utilisant, vous acceptez les
          présentes Conditions ainsi que toute autre politique ou condition mentionnée dans le Programme de fidélité ou
          publiée dans celui-ci, y compris, sans s&apos;y limiter, les conditions relatives aux promotions, les lignes
          directrices, de même que tout règlement ou toute condition applicable à certaines fonctionnalités ou
          promotions, lesquels sont expressément intégrés aux présentes Conditions par renvoi. Vous reconnaissez
          également avoir lu et compris notre déclaration de confidentialité (la{' '}
          <a href={privacyPolicyUrl}>«Déclaration de confidentialité»</a>).
        </TermsPlainText>
        <TermsPlainText>
          DE TEMPS À AUTRE, NOUS POUVONS METTRE À JOUR OU MODIFIER LES PRÉSENTES CONDITIONS D&apos;UTILISATION À NOTRE
          ENTIÈRE DISCRÉTION, ET PUBLIERONS LES CONDITIONS MISES À JOUR À L&apos;ADRESSE SUIVANTE:{' '}
          {merchantName || '[organisation name]'}. LES CONDITIONS D&apos;UTILISATION MISES À JOUR ENTRERONT EN VIGUEUR À
          COMPTER DE LA DATE D&apos;ENTRÉE EN VIGUEUR INDIQUÉE DANS LES CONDITIONS D&apos;UTILISATION (LA «DATE
          D&apos;ENTRÉE EN VIGUEUR»). TOUTE UTILISATION DU PROGRAMME DE FIDÉLITÉ APRÈS LA DATE D&apos;ENTRÉE EN VIGUEUR
          SIGNIFIE QUE VOUS AVEZ ACCEPTÉ LES CONDITIONS MISES À JOUR. VOTRE SEUL ET UNIQUE RECOURS SI VOUS
          N&apos;ACCEPTEZ PAS LES CONDITIONS D&apos;UTILISATION MISES À JOUR CONSISTE À CESSER D&apos;ACCÉDER AU
          PROGRAMME DE FIDÉLITÉ ET DE L&apos;UTILISER.
        </TermsPlainText>

        <TermsPlainText>
          LES PRÉSENTES CONDITIONS COMPRENNENT UNE ENTENTE VISANT À RÉGLER LES DIFFÉRENDS PAR ARBITRAGE, CE QUI SIGNIFIE
          QUE VOUS ET GLOBAL PAYMENTS RENONCEZ AU DROIT À UN PROCÈS DEVANT JURY ET ACCEPTEZ DE RÉSOUDRE TOUS LES
          DIFFÉRENDS EXCLUSIVEMENT PAR ARBITRAGE EXÉCUTOIRE SUR UNE BASE INDIVIDUELLE
        </TermsPlainText>

        <TermsPlainText>
          Si vous êtes une personne physique, vous devez être âgé d&apos;au moins 18 ans, résider aux États-Unis ou au
          Canada, et avoir la capacité juridique de conclure des contrats. Si vous êtes une entité, une organisation ou
          une entreprise, ou si vous agissez au nom de l&apos;une d&apos;entre elles, vous déclarez et garantissez que
          vous êtes un représentant autorisé de cette entité et que vous avez le pouvoir de lier celle-ci aux présentes
          Conditions, et vous acceptez de le faire. Vous déclarez que vous n&apos;utiliserez pas le Programme de
          fidélité, directement ou indirectement, dans le cadre d&apos;activités frauduleuses.
        </TermsPlainText>

        <TermsSubTitle>1. DESCRIPTION DU PROGRAMME DE FIDÉLITÉ</TermsSubTitle>

        <TermsPlainText>
          Global Payments fournit des services technologiques qui permettent aux Commerçants d&apos;offrir des
          programmes de fidélité et/ou de récompenses à leurs clients. En vous inscrivant au Programme de fidélité
          offert par Global Payments ou par un Commerçant utilisant les services de Global Payments, vous acceptez
          expressément les présentes conditions du programme.
        </TermsPlainText>

        <Paragraph>
          a. Vous pouvez vous inscrire au programme de fidélité d&apos;un Commerçant en vous abonnant directement auprès
          de ce dernier ou au moment de passer une commande, sous réserve des modalités et conditions propres au
          programme de fidélité du Commerçant. Une fois inscrit, vous pouvez accumuler des points lorsque vous effectuez
          des achats auprès de Commerçants, points que vous pourrez ensuite échanger contre des rabais ou d&apos;autres
          avantages. Si vous effectuez un retour, une rétrofacturation ou une demande de remboursement, les points
          associés à l&apos;achat concerné peuvent être annulés. Vous pouvez consulter le solde actuel de vos
          récompenses en cliquant sur le lien que vous recevez lors de votre inscription au programme de fidélité
          d&apos;un Commerçant.
        </Paragraph>

        <Paragraph>
          b. Si vous choisissez de vous inscrire au programme de fidélité d&apos;un Commerçant, vous acceptez que ce
          Commerçant puisse communiquer avec vous, au moyen des coordonnées que vous fournissez, afin de vous
          transmettre des renseignements sur le programme, des offres, ainsi que d&apos;autres communications de nature
          marketing ou transactionnelle. Tout renseignement partagé par Global Payments avec les Commerçants est
          assujetti à notre Déclaration de confidentialité. Une fois qu&apos;un Commerçant a reçu de Global Payments les
          renseignements que vous avez fournis, leur utilisation et leur gestion relèveront du Commerçant, qui peut
          avoir ses propres pratiques et politiques en matière de confidentialité. Global Payments n&apos;autorise pas
          les Commerçants à envoyer des messages promotionnels à votre numéro de téléphone mobile. Les Commerçants ne
          peuvent vous envoyer de tels messages que si vous leur en donnez l&apos;autorisation expresse.
        </Paragraph>
        <Paragraph>
          c. Chaque Commerçant est entièrement responsable de l&apos;exploitation et de la gestion de son propre
          programme de fidélité, notamment en ce qui concerne l&apos;établissement du nombre de points que vous pouvez
          accumuler lors de vos achats, la définition des seuils d&apos;échange, ainsi que les modalités et le moment où
          les points peuvent être échangés contre des récompenses. Les Commerçants ont la capacité de modifier leur
          programme de fidélité et/ou d&apos;ajuster le solde de points détenu par vous ou par tout autre client
          d&apos;un Commerçant. Global Payments n&apos;est pas responsable de vous aviser si un Commerçant modifie un
          élément de son programme de fidélité ou cesse d&apos;en offrir un. Le Commerçant est seul responsable de vous
          communiquer toute modification liée au programme ou au solde de points.
        </Paragraph>
        <Paragraph>
          d. Les points accumulés dans le cadre de tout programme de fidélité offert par Global Payments ou par un
          Commerçant utilisant les services de Global Payments n&apos;ont aucune valeur monétaire et ne peuvent être
          transférés, échangés ni vendus contre de l&apos;argent comptant. Sous réserve des exigences de notification
          prévues par les Lois et Règlements applicables, Global Payments se réserve le droit, à sa seule discrétion et
          en tout temps, de modifier, suspendre, résilier, réévaluer ou annuler son propre programme de fidélité et/ou
          les services technologiques permettant aux Commerçants d&apos;offrir des programmes de fidélité par
          l&apos;intermédiaire de Global Payments. Si le Programme de fidélité offert par Global Payments est mis fin
          par le Commerçant, Global Payments vous en informera, et vous disposerez alors d&apos;un délai maximal de 30
          jours pour utiliser les points ou récompenses accumulés. Global Payments se réserve le droit de statuer, à sa
          seule discrétion, sur tout écart ou différend lié à l&apos;attribution des récompenses ou aux présentes
          conditions du programme, et vous acceptez de vous conformer à toute décision rendue à cet égard.
        </Paragraph>
        <Paragraph>
          e. Les achats et les transactions de paiement que vous effectuez dans le cadre du programme de fidélité sont
          des transactions entre vous et le commerçant uniquement, et non avec Global Payments ou l&apos;une de ses
          affiliées. Global Payments n&apos;est pas le vendeur de quelque produit ou service que ce soit offert par les
          commerçants et ne fait pas partie des transactions de paiement effectuées dans le cadre du programme de
          fidélité.
        </Paragraph>
        <Paragraph>
          f. Le commerçant se réserve le droit de mettre fin au programme de fidélité, de le modifier ou de le changer
          moyennant un préavis de trente (30) jours, et ce, sans préavis en cas de changement législatif.
        </Paragraph>
        <Paragraph>
          g. Si Global Payments cesse de fournir la solution technique permettant au commerçant d&apos;exploiter le
          programme de fidélité, sans préavis, pour des raisons indépendantes de la volonté raisonnable du commerçant,
          ce dernier pourra mettre fin au programme de fidélité avec effet immédiat. Dans un tel cas, le client du
          commerçant perdra tous les points de fidélité et les avantages associés à sa participation au programme de
          fidélité.
        </Paragraph>
        <Paragraph>
          h. Le commerçant se réserve également le droit de modifier ou de compléter les présentes conditions générales,
          notamment dans l&apos;intérêt de la simplicité, pour assurer le traitement sécurisé des données personnelles
          et des points de fidélité, et/ou pour prévenir tout abus du système. Toute modification des conditions
          générales sera communiquée au client du commerçant à l&apos;avance par courriel. En cas de désaccord avec la
          modification, le client du commerçant a le droit de mettre fin à sa participation au programme de fidélité
          avec effet immédiat avant la date d&apos;entrée en vigueur desdites modifications.
        </Paragraph>

        <TermsSubTitle>2. PARTICIPATION AU PROGRAMME DE FIDÉLITÉ</TermsSubTitle>

        <Paragraph>
          a. Le programme de fidélité permet aux clients du commerçant d&apos;accumuler des points de fidélité lors des
          paiements par carte, puis d&apos;échanger la récompense correspondant aux points de fidélité accumulés, selon
          les modalités décrites dans les présentes conditions générales. La participation au programme de fidélité est
          soumise aux présentes conditions (les “Conditions”).
        </Paragraph>
        <Paragraph>
          b. Toute personne physique âgée d&apos;au moins 18 ans peut devenir participante au programme de fidélité. En
          acceptant les présentes conditions générales, la personne souhaitant adhérer au programme de fidélité confirme
          qu&apos;elle est âgée de 18 ans.
        </Paragraph>
        <Paragraph>
          c. Lors de l&apos;invitation à adhérer au programme de fidélité, les présentes conditions générales sont mises
          à la disposition du client, lequel doit y consentir pour pouvoir participer au programme de fidélité, ainsi
          que la déclaration de confidentialité, dont le client doit confirmer avoir pris connaissance.
        </Paragraph>
        <Paragraph>
          d. Il est également demandé au client du commerçant de saisir son numéro de téléphone mobile, lequel sera
          utilisé pour confirmer sa volonté d&apos;adhérer au programme de fidélité, pour l&apos;identifier en tant que
          client du commerçant, et sera lié à son compte du programme de fidélité. Le client du commerçant n&apos;est
          pas autorisé à saisir le numéro de téléphone mobile d&apos;une autre personne.
        </Paragraph>
        <Paragraph>
          e. Le client du commerçant adhère au programme de fidélité au moment où il confirme «Confirmer et recevoir les
          avantages» sur le terminal de paiement, et à partir de ce moment, les points de fidélité sont accumulés dans
          le cadre du programme de fidélité conformément aux règles énoncées à l&apos;article 2.
        </Paragraph>
        <Paragraph>
          f. La participation au programme de fidélité est gratuite et n&apos;implique aucune obligation d&apos;acheter
          des biens ou des services auprès du commerçant.
        </Paragraph>
        <Paragraph>g. Activités autorisées. En utilisant le programme de fidélité, vous acceptez que:</Paragraph>
        <SubParagraph>
          i. Vous n&apos;utiliserez pas le programme de fidélité d&apos;une manière qui enfreint les lois et règlements
          applicables, les présentes conditions ou toute autre politique.
        </SubParagraph>
        <SubParagraph>
          ii. Vous ne fournirez pas de fausses informations vous concernant, ne prétendrez pas être une autre personne,
          ne recueillerez pas d&apos;informations sur d&apos;autres utilisateurs et ne tenterez pas de tromper qui que
          ce soit sur votre identité ou sur la véracité ou l&apos;exactitude des données que vous transmettez par
          l&apos;intermédiaire du programme de fidélité.
        </SubParagraph>
        <SubParagraph>
          iii. Vous ne porterez pas atteinte au programme de fidélité, ne le désactiverez pas, ne le perturberez pas, ne
          le surchargerez pas, ne vous y interposerez pas, et ne tenterez pas d&apos;y accéder sans autorisation, ni à
          empêcher une autre personne de l&apos;utiliser et d&apos;en profiter.
        </SubParagraph>
        <SubParagraph>
          iv. Global Payments peut suspendre ou mettre fin à votre utilisation du programme de fidélité, à sa seule
          discrétion, en cas de violation réelle ou présumée de ces limitations ou de toute autre politique ou règle
          applicable mentionnée dans les présentes conditions d&apos;utilisation.
        </SubParagraph>

        <Paragraph>
          h. Modes d&apos;acceptation
          <br />
          Vous reconnaissez et acceptez qu&apos;en cliquant sur les boutons «Démarrer», «Accepter», «Soumettre», «Créer
          un compte» ou tout autre bouton similaire sur le terminal de point de vente (TPV), ou sur toute autre
          fonctionnalité offerte dans le cadre de notre programme de fidélité et associée aux présentes conditions ou à
          tout autre document électronique autorisant Global Payments à vous fournir le programme de fidélité, vous
          manifestez votre intention de signer les présentes conditions et/ou tout autre accord applicable.
          <br />
          Vous acceptez également que le fait de cliquer sur ces boutons sur le TPV constitue votre signature
          électronique des présentes conditions ou de tout autre document affiché avec ces boutons et lié au programme
          de fidélité.
          <br />
          Vous convenez en outre que votre signature électronique sur les présentes conditions et tout autre document
          aura la même valeur légale, en vertu des lois provinciales et fédérales, que si vous aviez signé ces documents
          à lencre sur support papier.
        </Paragraph>

        <TermsSubTitle>3. ACCUMULATION ET ÉTAT DES POINTS DE FIDÉLITÉ</TermsSubTitle>
        <TermsPlainText>
          Pour chaque paiement effectué dans le cadre du Programme de fidélité au terminal de paiement du Marchand, le
          client du Marchand accumulera un (1) point de fidélité pour chaque dollar américain dépensé.
          L&apos;information concernant le nombre de points de fidélité accumulés sera affichée sur le terminal de
          paiement à chaque transaction.
        </TermsPlainText>

        <TermsSubTitle>4. ÉCHANGE DES POINTS DE FIDÉLITÉ</TermsSubTitle>
        <Paragraph>
          a. Lorsque le seuil de {pointThreshhold || '[point-threshhold-value]'} points de fidélité est atteint, les
          points de fidélité correspondants seront automatiquement convertis en une récompense d&apos;une valeur de{' '}
          {rewardAmount || '[reward value]'}. À partir de ce moment, le client du Marchand aura gagné la récompense et
          disposera d&apos;un délai de soixante (60) jours pour l&apos;échanger dans le cadre du Programme de fidélité.
        </Paragraph>
        <Paragraph>
          b. Si le seuil mentionné ci-dessus est atteint, une notification s&apos;affichera sur le terminal de point de
          vente (TPV) du Marchand pour informer le client qu&apos;il a droit à une récompense.
        </Paragraph>
        <Paragraph>
          c. T Les points de fidélité accumulés pour des achats effectués chez le Marchand seront annulés si le Marchand
          rembourse les fonds au client.
        </Paragraph>
        <Paragraph>
          d. Les points de fidélité accumulés sont graduellement supprimés après trois cent soixante-cinq (365) jours
          suivant la date à laquelle ils ont été crédités dans le cadre du Programme de fidélité (à moins qu&apos;ils
          n&apos;aient été convertis en récompense entre-temps). Conformément à la Section 4.a des présentes Conditions
          générales, une récompense sera supprimée soixante (60) jours après la première date à laquelle elle aurait pu
          être échangée.
        </Paragraph>

        <TermsSubTitle>5. RÉSILIATION DE LA PARTICIPATION AU PROGRAMME DE FIDÉLITÉ</TermsSubTitle>
        <Paragraph>
          a. Si le client du Marchand ne souhaite pas participer au Programme de fidélité, il peut se retirer du
          Programme en informant le Marchand de sa volonté de mettre fin à sa participation.
        </Paragraph>
        <Paragraph>
          b. En cas de résiliation de la participation au Programme de fidélité, le client du Marchand perdra tous les
          points de fidélité et avantages associés à sa participation, et ses données seront supprimées du système une
          fois que le Marchand aura informé Global Payments que la participation du client au Programme de fidélité a
          été résiliée.
        </Paragraph>
        <Paragraph>
          c. En cas de réinscription au Programme de fidélité, aucun avantage découlant de la participation antérieure
          du client ne sera accordé.
        </Paragraph>
        <Paragraph>
          d. Le Marchand peut résilier le compte du client en cas de violation des présentes Conditions, moyennant un
          préavis de soixante (60) jours.
        </Paragraph>
        <Paragraph>
          e. D&apos;autres motifs de résiliation du Programme de fidélité sont énoncés aux Sections 1.f et 1.g des
          présentes Conditions générales.
        </Paragraph>

        <TermsSubTitle>6. LOI APPLICABLE ET RÈGLEMENT DES DIFFÉRENDS</TermsSubTitle>

        <Paragraph>
          <TermsPlainText>a. Loi applicable </TermsPlainText>
          <TermsPlainText style={{ marginLeft: 18 }}>
            Vous acceptez que tout différend ou toute controverse, de quelque nature que ce soit (qu&apos;il soit
            contractuel, délictuel ou autre), découlant de, se rapportant à, ou lié à : (a) les présentes Conditions,
            (b) les relations découlant des présentes Conditions, ou (c) la validité, la portée, l&apos;interprétation
            ou l&apos;applicabilité des dispositions relatives au choix de la loi applicable et du tribunal compétent
            prévues dans les présentes Conditions, soit régi par les lois de l&apos;État de Géorgie, aux États-Unis,
            ainsi que par les lois fédérales applicables des États-Unis, et ce, nonobstant toute règle relative aux
            conflits de lois. Toutefois, la Loi fédérale sur l&apos;arbitrage (Federal Arbitration Act, 9 U.S.C. § 1 et
            suivants) régit l&apos;interprétation et l&apos;application de la Section 6.b, lorsque cela est permis. La
            Convention des Nations Unies sur les contrats de vente internationale de marchandises et la Loi uniforme sur
            les transactions d&apos;informations informatisées (Uniform Computer Information Transactions Act) ne
            s&apos;appliquent pas aux présentes Conditions de service.
          </TermsPlainText>
        </Paragraph>
        <Paragraph>
          b. <b>Règlement des différends – Arbitrage</b>
          <Paragraph>
            ARBITRAGE OBLIGATOIRE: TOUT DIFFÉREND OU REVENDICATION DÉCOULANT DU PRÉSENT CONTRAT, S&apos;Y RAPPORTANT OU
            LIÉ DE QUELQUE MANIÈRE QUE CE SOIT AU CONTRAT OU AUX RELATIONS QUI EN DÉCOULENT DOIT ÊTRE RÉGLÉ PAR VOIE
            D&apos;ARBITRAGE EXÉCUTOIRE, PLUTÔT QUE DEVANT UN TRIBUNAL.
            <br />
            TOUTEFOIS, VOUS POUVEZ FAIRE VALOIR DES RÉCLAMATIONS DEVANT LA COUR DES PETITES CRÉANCES SI (1) VOS
            RÉCLAMATIONS RELÈVENT DE LA COMPÉTENCE DE CETTE COUR; (2) L&apos;AFFAIRE DEMEURE EN TOUT TEMPS DEVANT LA
            COUR DES PETITES CRÉANCES; ET (3) L&apos;AFFAIRE EST TRAITÉE UNIQUEMENT DE FAÇON INDIVIDUELLE (ET NON EN
            RECOURS COLLECTIF OU REPRÉSENTATIF).
            <br />
            L&apos;ARBITRAGE NE SE TIENT PAS DEVANT UN JURY ET PEUT COMPORTER UNE PROCÉDURE DE COMMUNICATION DE LA
            PREUVE PLUS LIMITÉE QUE DEVANT UN TRIBUNAL. TOUT ARBITRAGE EN VERTU DU PRÉSENT CONTRAT SERA MENÉ UNIQUEMENT
            SUR UNE BASE INDIVIDUELLE. LES ARBITRAGES COLLECTIFS, LES ACTIONS COLLECTIVES, LES POURSUITES PAR UN
            PARTICULIER AGISSANT COMME PROCUREUR GÉNÉRAL PRIVÉ ET LA CONSOLIDATION AVEC D&apos;AUTRES PROCÉDURES
            D&apos;ARBITRAGE NE SONT PAS AUTORISÉS.
          </Paragraph>
          <Paragraph>
            La sentence ou la décision de l&apos;arbitre n&apos;aura aucun effet sur les questions ou réclamations
            impliquées dans une procédure entre Xenial et toute personne ou entité qui n&apos;est pas partie à
            l&apos;arbitrage.
            <br />
            L&apos;arbitre peut accorder des réparations monétaires, déclaratoires ou injonctives uniquement en faveur
            de la partie individuelle demandant réparation et uniquement dans la mesure nécessaire pour accorder la
            réparation justifiée par la réclamation individuelle de cette partie. La sentence arbitrale, le cas échéant,
            ne s&apos;appliquera à aucune personne ou entité qui n&apos;est pas partie à l&apos;arbitrage.
            <br />
            Cependant, rien dans la présente Section ou dans le présent Contrat n&apos;empêche une partie de porter
            certaines questions à l&apos;attention d&apos;organismes fédéraux, provinciaux ou municipaux. Ces organismes
            peuvent, si la loi le permet, demander réparation en votre nom. En outre, nonobstant ce qui précède, rien
            dans la présente Section ou dans le présent Contrat n&apos;interdit à une partie de demander à un tribunal
            compétent une ordonnance de ne pas faire temporaire, une injonction provisoire ou toute autre réparation
            équitable.
          </Paragraph>
          <Paragraph>
            La Loi fédérale sur l&apos;arbitrage (Federal Arbitration Act, 9 U.S.C. § 1 et suivants) régit
            l&apos;interprétation et l&apos;application des dispositions d&apos;arbitrage de la présente section.
            L&apos;arbitrage sera administré par JAMS (www.jamsadr.com).
            <br />
            Pour les réclamations de plus de 250 000$ US, les Règles et procédures d&apos;arbitrage exhaustives de JAMS
            en vigueur au moment du début de l&apos;arbitrage s&apos;appliqueront (et, en l&apos;absence de telles
            règles, les règles par défaut de JAMS s&apos;appliqueront).
            <br />
            Pour les réclamations de 250 000$ US ou moins, les Règles et procédures d&apos;arbitrage simplifiées de JAMS
            en vigueur au moment du début de l&apos;arbitrage s&apos;appliqueront (et, en l&apos;absence de telles
            règles, les règles par défaut de JAMS s&apos;appliqueront). À moins que l&apos;arbitre (ou les arbitres) ne
            détermine(nt) qu&apos;une autre approche est requise pour des raisons d&apos;équité ou de justice: (i) tout
            arbitrage se déroulera dans le comté de Muscogee, en Géorgie (toutefois, pour des raisons de commodité,
            toute partie ou son avocat pourra participer par téléphone); et (ii) l&apos;arbitre (ou les arbitres)
            supervisera(ont) une procédure de communication de la preuve limitée, en tenant compte du montant en litige
            et du souhait des parties de maintenir la procédure efficace et peu coûteuse.
            <br />
            Toute décision rendue dans le cadre de la procédure d&apos;arbitrage sera définitive et liera chacune des
            parties à l&apos;arbitrage, et pourra être homologuée par tout tribunal compétent. Les parties
            s&apos;engagent à préserver la nature confidentielle de la procédure d&apos;arbitrage, sauf si cela est
            nécessaire pour faire exécuter une décision ou se conformer aux lois applicables.
          </Paragraph>
          <Paragraph>
            Si le montant total des dommages-intérêts réclamés dans un arbitrage est de 10 000$ US ou moins, à
            l&apos;exclusion de vos frais juridiques (une «Petite réclamation en arbitrage»), l&apos;arbitre peut, si
            vous avez gain de cause, vous accorder des honoraires d&apos;avocat raisonnables et des frais (distincts des
            Frais d&apos;arbitrage, tels que définis ci-dessous), mais ne peut accorder à Global Payments ses propres
            honoraires d&apos;avocat ou frais (également distincts des Frais d’arbitrage), sauf si l&apos;arbitre
            conclut que votre réclamation est frivole ou a été présentée de mauvaise foi. Dans le cas d&apos;une Petite
            réclamation en arbitrage, Global Payments paiera tous les frais de dépôt, frais administratifs et honoraires
            d&apos;arbitre (ensemble, les «Frais d&apos;arbitrage»). Vous devez soumettre toute demande de paiement des
            Frais d&apos;arbitrage à JAMS au moment de la présentation de votre demande d&apos;arbitrage. Cependant, si
            vous souhaitez que Global Payments avance les Frais d&apos;arbitrage pour une Petite réclamation avant le
            dépôt officiel de votre demande, Global Payments le fera à votre demande écrite, laquelle devra être envoyée
            à l&apos;adresse indiquée au paragraphe 19 ci-dessous.
          </Paragraph>
          <Paragraph>
            Si vos demandes de dommages-intérêts dans le cadre d&apos;un arbitrage dépassent 10 000$, à l&apos;exclusion
            de vos honoraires d&apos;avocat («réclamation d&apos;arbitrage majeure»), l&apos;arbitre peut accorder à la
            partie gagnante le remboursement de ses honoraires d&apos;avocat et frais raisonnables, ou répartir ces
            honoraires et frais entre vous et Global Payments (ces frais étant distincts des frais d&apos;arbitrage).
            Dans le cas d&apos;une réclamation d&apos;arbitrage majeure, si vous êtes en mesure de démontrer que les
            frais d&apos;arbitrage seraient prohibitifs comparativement aux frais d&apos;un litige devant les tribunaux,
            Global Payments paiera la portion des frais d&apos;arbitrage que l&apos;arbitre jugera nécessaire pour
            éviter que l&apos;arbitrage ne devienne excessivement coûteux.
          </Paragraph>
          <Paragraph>
            Choix du tribunal compétent: Un tribunal, et non l&apos;arbitre, statuera sur toute question relative à la
            validité, à la portée et/ou à l&apos;applicabilité de la présente Section 6.b. Toute action judiciaire (par
            opposition à un arbitrage) portant sur, se rapportant à ou impliquant la validité, la portée et/ou
            l&apos;applicabilité de la présente Section 6.b ou toute autre question connexe devra être intentée soit
            devant les tribunaux de l&apos;État de Géorgie siégeant dans le comté de Muscogee, soit devant la Cour de
            district des États-Unis pour le district nord de la Géorgie. Vous acceptez expressément la compétence
            exclusive de ces tribunaux. Par la présente, vous acceptez et consentez à la compétence personnelle et au
            lieu de juridiction de ces tribunaux, et renoncez expressément à toute objection que vous pourriez autrement
            soulever quant à la compétence personnelle ou au lieu de juridiction devant ces tribunaux.
          </Paragraph>
        </Paragraph>
        <Paragraph>
          c. Renonciation aux recours collectifs: VOUS RECONNAISSEZ ET ACCEPTEZ QUE TOUS LES DIFFÉRENDS DÉCOULANT DES
          PRÉSENTES CONDITIONS OU S&apos;Y RAPPORTANT SERONT RÉSOLUS À TITRE INDIVIDUEL, SANS AVOIR RECOURS À UNE
          QUELCONQUE FORME DE RECOURS COLLECTIF, ET NE SERONT PAS REGROUPÉS AVEC LES RÉCLAMATIONS D&apos;AUTRES PARTIES.
          VOUS ACCEPTEZ ÉGALEMENT DE RENONCER – ET PAR LA PRÉSENTE VOUS RENONCEZ – AU DROIT DE PARTICIPER À UNE ACTION
          COLLECTIVE OU DE MENER UNE PROCÉDURE JUDICIAIRE OU ARBITRALE SUR UNE BASE COLLECTIVE.
        </Paragraph>
        <Paragraph>
          d. Vous et le Marchand devrez tenter de résoudre à l&apos;amiable tout différend découlant des présentes
          Conditions générales.
        </Paragraph>

        <TermsSubTitle>7. EXCLUSION DE GARANTIES, RENONCIATION ET LIMITATION DE RESPONSABILITÉ</TermsSubTitle>

        <Paragraph>
          a. EXCLUSION DE GARANTIES
          <br />
          YVOUS COMPRENEZ ET ACCEPTEZ EXPRESSÉMENT QUE VOTRE UTILISATION DU PROGRAMME DE FIDÉLITÉ AINSI QUE DE TOUTE
          INFORMATION, PRODUIT ET AUTRE CONTENU (Y COMPRIS CEUX FOURNIS PAR DES TIERS) INCLUS OU ACCESSIBLES VIA LE
          PROGRAMME DE FIDÉLITÉ SE FAIT À VOS RISQUES EXCLUSIFS. LE SERVICE EST FOURNI «TEL QUEL» ET «SELON
          DISPONIBILITÉ». GLOBAL PAYMENTS ET SES FOURNISSEURS TIERS NE SONT AUCUNEMENT RESPONSABLES DES PRODUITS OU
          SERVICES FOURNIS PAR LES MARCHANDS QUI CAUSERAIENT DES DOMMAGES, QUI SERAIENT INACCEPTABLES OU QUI NE
          RÉPONDAIENT PAS À VOS BESOINS OU ATTENTES.
          <br />
          SAUF GARANTIES EXPRESSES PRÉVUES AUX PRÉSENTES, GLOBAL PAYMENTS ET SES FOURNISSEURS TIERS DÉCLINENT
          EXPLICITEMENT TOUTES GARANTIES EXPRESSES OU IMPLICITES CONCERNANT LE PROGRAMME DE FIDÉLITÉ AINSI QUE TOUTE
          INFORMATION, PRODUIT OU AUTRE CONTENU (Y COMPRIS CEUX DE TIERS) INCLUS OU ACCESSIBLES VIA LE PROGRAMME,
          INCLUANT, MAIS SANS S&apos;Y LIMITER, LES GARANTIES IMPLICITES DE QUALITÉ MARCHANDE, D&apos;APTITUDE À UN
          USAGE PARTICULIER, DE TITRE, D&apos;ABSENCE DE CONTREFAÇON ET DE QUALITÉ.
          <br />
          GLOBAL PAYMENTS NE GARANTIT PAS QUE LES INFORMATIONS ACCESSIBLES PAR LE PROGRAMME DE FIDÉLITÉ SOIENT EXACTES,
          COMPLÈTES, FIABLES, ACTUELLES OU SANS ERREUR
        </Paragraph>

        <Paragraph>
          b. DÉCHARGE.
          <br />
          GLOBAL PAYMENTS ET SES FOURNISSEURS TIERS NE FONT AUCUNE DÉCLARATION NI NE DONNENT AUCUNE GARANTIE QUANT À:
          (I) la capacité du programme de fidélité à répondre à vos besoins; (II) la fiabilité, la disponibilité, la
          ponctualité, la pertinence, l&apos;exactitude ou l&apos;exhaustivité du programme de fidélité; (III) les
          résultats que vous pourriez obtenir en utilisant le programme de fidélité; (IV) le bon fonctionnement ou
          l&apos;utilisation du programme de fidélité sans interruption ni erreur; ou (V) la qualité du service, ou des
          produits ou services, informations ou tout autre matériel acheté ou obtenu par l&apos;entremise du programme
          de fidélité, qui correspondra à vos attentes.
        </Paragraph>
        <Paragraph>
          c. LIMITATION DE RESPONSABILITÉ
          <br />
          EN AUCUN CAS GLOBAL PAYMENTS NE POURRA ÊTRE TENUE RESPONSABLE, EN VERTU D&apos;UN CONTRAT, POUR NÉGLIGENCE,
          RESPONSABILITÉ STRICTE OU TOUTE AUTRE THÉORIE JURIDIQUE, DE TOUT DOMMAGE DIRECT, INDIRECT, PARTICULIER,
          PUNITIF, ACCESSOIRE, EXEMPLAIRE OU CONSÉCUTIF, Y COMPRIS, SANS S&apos;Y LIMITER, LES PERTES DE PROFITS, LA
          PERTE DE CLIENTÈLE, L&apos;UTILISATION, LES DONNÉES OU TOUTES AUTRES PERTES INTANGIBLES, MÊME SI GLOBAL
          PAYMENTS A ÉTÉ INFORMÉE DE LA POSSIBILITÉ DE TELS DOMMAGES ET MÊME SI UN RECOURS PRÉVU AUX PRÉSENTES N&apos;A
          PAS RÉPONDU À SON OBJECTIF ESSENTIEL. DANS LA MESURE MAXIMALE PERMISE PAR LA LOI, LA RESPONSABILITÉ GLOBALE DE
          GLOBAL PAYMENTS ENVERS VOUS OU TOUT TIERS, QUELLE QUE SOIT LA CIRCONSTANCE, EST LIMITÉE À CENT DOLLARS (100
          $).
        </Paragraph>
        <Paragraph>
          d. Exemptions provinciales
          <br />
          Certaines provinces ne permettent pas l&apos;exclusion des garanties implicites ni la limitation de
          responsabilité pour les dommages accessoires ou indirects. Par conséquent, les limitations ou exclusions
          ci-dessus peuvent ne pas s&apos;appliquer à vous. DANS CES PROVINCES, LA RESPONSABILITÉ DE GLOBAL PAYMENTS
          SERA LIMITÉE DANS LA MESURE MAXIMALE PERMISE PAR LA LOI.
        </Paragraph>
        <Paragraph>
          e. Appui aux limitations. Chaque partie reconnaît que l&apos;autre partie a conclu les présentes Conditions en
          se fondant sur les limitations de responsabilité énoncées aux présentes, lesquelles constituent un fondement
          essentiel de l&apos;entente entre les parties.
        </Paragraph>

        <TermsSubTitle>8. INDEMNISATION</TermsSubTitle>
        <Paragraph>
          Vous acceptez de défendre, d&apos;indemniser et de tenir indemnes Global Payments ainsi que ses
          administrateurs, dirigeants, employés, sociétés affiliées et mandataires de toute réclamation, responsabilité,
          dommage, dépense, coût, action ou demande d&apos;un tiers, y compris, sans s&apos;y limiter, les frais
          juridiques et comptables raisonnables, découlant ou résultant: (a) de votre violation des présentes Conditions
          ou de toute autre politique; (b) de votre accès, utilisation ou utilisation abusive du Contenu de tiers ou du
          Programme de fidélité. Global Payments vous avisera de toute réclamation, poursuite ou procédure de ce type.
          Global Payments se réserve le droit d&apos;assumer la défense et le contrôle exclusifs de toute affaire
          faisant l&apos;objet d&apos;une indemnisation en vertu de la présente section. Le cas échéant, vous acceptez
          de collaborer à toute demande raisonnable visant à appuyer la défense de Global Payments dans le cadre de
          cette affaire.
        </Paragraph>

        <TermsSubTitle>9. DISPOSITIONS DIVERSES</TermsSubTitle>

        <Paragraph>
          a. Avis. Tous les avis devant être donnés à Global Payments en vertu des présentes conditions doivent être
          faits par écrit et envoyés à l&apos;adresse suivante: Global Payments Direct, Inc., 3550 Lenox Road, Suite
          3000, Atlanta, Georgia 30326, À l&apos;attention de: Secrétaire général. Ces avis seront réputés reçus (i) au
          moment de la réception, s&apos;ils sont remis en main propre, ou (ii) le lendemain de leur envoi, s&apos;ils
          sont livrés par un service de messagerie express reconnu à l&apos;échelle internationale fournissant une
          preuve de livraison.
        </Paragraph>
        <Paragraph>
          b. Cession. Vous ne pouvez céder les présentes Conditions ni aucun droit ou obligation qui en découle, que ce
          soit en vertu de la loi ou autrement, sans notre consentement écrit préalable, et toute cession tentée sans ce
          consentement peut être nulle. Nous nous réservons le droit de céder librement les présentes Conditions ainsi
          que les droits et obligations qui en découlent à tout tiers, sans préavis ni consentement. Sous réserve de ce
          qui précède, les présentes Conditions lient les parties aux présentes ainsi que leurs successeurs et
          cessionnaires autorisés, et leur profitent.
        </Paragraph>
        <Paragraph>
          c. Si une disposition des présentes Conditions est jugée invalide par un tribunal compétent, l&apos;invalidité
          de cette disposition n&apos;affectera pas la validité des autres dispositions des présentes Conditions, qui
          resteront pleinement en vigueur. Le fait que Global Payments ne mette pas en œuvre ou n’applique pas une
          disposition des présentes Conditions ne sera pas interprété comme une renonciation à cette disposition ou à
          toute autre disposition des présentes. Aucune renonciation ne sera effective à l&apos;égard de Global
          Payments, sauf si elle est faite par écrit, et aucune renonciation ne sera interprétée comme une renonciation
          dans un autre cas ou dans une instance ultérieure. Sauf accord exprès entre Global Payments et vous, les
          présentes Conditions, y compris toute politique de Global Payments régissant le Programme de fidélité
          mentionnée aux présentes, constituent l&apos;intégralité de l&apos;entente entre vous et Global Payments à
          l&apos;égard de l&apos;objet des présentes, et remplacent tous les accords antérieurs ou contemporains,
          qu&apos;ils soient écrits ou oraux, entre vous et Global Payments concernant cet objet. Les titres des
          sections sont fournis uniquement pour des raisons pratiques et n&apos;auront aucune valeur juridique.
        </Paragraph>
      </TermsPlainTextWrapper>
    </TermsTextWrapper>
  );
};
